import { Button, Form, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { remitterRegisteration } from "../../../ApiServices/Apifun";
import VerifyModal from "../../../Common/VerifyModal";
import { Globalendpoints } from "../../../ApiServices/global";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";
import {
  aadharPattern,
  deviceOptions,
  dispatchtoast,
  getLocalStorageItem,
  handleSubmitForAeps,
  mantrairisPIDOPTS,
  mobilePattern,
  parseXml,
  pincodePattern,
  startekPIDOPTS,
} from "../../../Utils";
import CommonInput from "../../../Common/CommonInput";
import VerifyModal3 from "../../../Common/VerifyModal3";
import axios from "axios";
import { xml2json } from "../../../Utils/xml2json";

const RemitterReg3 = () => {
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const [form] = Form.useForm();
  const formref = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [otherfields, setOtherFields] = useState({});
  const [pidData, setPidData] = useState("");
  const [response, setResponse] = useState({});
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const navigate = useNavigate();
  const location = useLocation();
  const mobile = location?.state?.mobile;
  const provider = location?.state?.provider;
  useEffect(() => {
    dispatch(setselectedTab("24"));
    if (!memberServices.includes("4")) {
      navigate("/not-Available");
    }
  }, []);
  const handleAdd = (val) => {
    setBtnLoading(true);
  };
  const formatXmlToSingleQuote = (xmlString) => {
    let compact = xmlString.replace(/\r?\n|\r/g, "").replace(/\s{2,}/g, " ");

    compact = compact.replace(/"/g, "'");
    return compact.trim();
  };
  const capture = (val, port = 11100) => {
    setBtnLoading(true);
    axios({
      method: "CAPTURE", // Set the custom request method here
      url:
        val.device === "morpho"
          ? `https://localhost:${port}/capture`
          : val.device === "startek"
            ? "https://localhost:11200/rd/capture"
            : `https://127.0.0.1:${port}/rd/capture`,
      data:
        val.device === "morpho"
          ? provider === "FINO"
            ? '<PidOptions ver="1.0">' +
              '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" env="P" otp="" wadh="18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=" posh=""/>' +
              "</PidOptions>"
            : '<PidOptions ver="1.0">' +
              '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" env="P" otp="" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh=""/>' +
              "</PidOptions>"
          : val.device === "mantra"
            ? provider === "FINO"
              ? `<?xml version="1.0"?> 
     <PidOptions ver="1.0"> 
      <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" 
 timeout="10000" wadh="18f4CEiXeXcfGXvgWA/blxD+w2pw7hfQPY45JMytkPw=" posh="UNKNOWN" env="P"> 
</Opts> 
</PidOptions>`
              : `<?xml version="1.0"?>
<PidOptions ver="1.0">
    <Opts
        fCount="1"
        fType="2"
        iCount="0"
        iType="0"
        pCount="0"
        pType="0"
        format="0"
        pidVer="2.0"
        timeout="10000"
        otp=""
        env="P"
        wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc="
        posh="UNKNOWN"/>
</PidOptions>`
            : val.device === "startek"
              ? startekPIDOPTS
              : mantrairisPIDOPTS,
      headers: {
        "Content-Type": "text/xml",
        Accept: "text/xml",
      },
    })
      .then((response) => {
        const parsed = parseXml(response.data);
        const xmltojson = JSON.parse(xml2json(parsed).replace("undefined", ""));
        if (xmltojson.PidData.Resp.errCode !== "0") {
          dispatchtoast(
            `Failed to fetch fingerprint because of ${xmltojson.PidData.Resp.errInfo}`,
            true,
          );
          setBtnLoading(false);
        } else {
          dispatchtoast("Fingerprint Captured SuccessFully");
          const parsed = parseXml(response.data);
          console.log(response.data, "parsed", typeof response.data);
          setPidData(response.data);
          const formdata = new FormData();
          formdata.append("BankId", provider);
          formdata.append("SenderMobileNumber", mobile);
          formdata.append("SenderName", val.SenderName);
          formdata.append("SenderPin", val.SenderPin);
          formdata.append("AadharNumber", val.AadharNumber);
          formdata.append("BioPid", formatXmlToSingleQuote(response.data));
          formdata.append("BioType", "FIR");

          remitterRegisteration(formdata)
            .then((res) => {
              if (res.status) {
                setResponse(res.data);
                setIsOpen(true);
                setOtherFields(val);
                //  navigate("/moneyTransfer/verifyOtp",{state:{mobile:fields.mobile,otp_refrence_id:res.data.otprefrenceid}})
              }
            })
            .catch((err) => console.log(err))
            .finally((err) => setBtnLoading(false));
        }
      })
      .catch((error) => {
        setBtnLoading(false);
      });
  };
  useEffect(() => {
    form.setFieldsValue({
      bankId: provider,
      mobile: mobile,
    });
  }, []);
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-1 place-items-start">
        <div className="prepaid animate-slide-in w-full lg:w-1/2 bg-white shadow-normal  rounded-3xl p-5">
          <p className="font-bold text-[15px] mb-2">Add Remitter</p>
          <Form
            name="basic"
            form={form}
            ref={formref}
            onFinishFailed={(err) => console.log(err)}
            // onFinish={(val) => handleAdd(val)}
            onFinish={(val) => handleSubmitForAeps(val, capture, setBtnLoading)}
          >
            <Form.Item
              name={`bankId`}
              label={"Bank Id"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select Bank Id!",
                },
              ]}
            >
              <Select
                disabled
                placeholder="Select Bank Id"
                className="w-36"
                options={[
                  { label: "FINO BANK", value: "FINO" },
                  { label: "AIRTEL BANK", value: "ARTL" },
                ]}
              />
            </Form.Item>{" "}
            <Form.Item
              name={`mobile`}
              label={"Mobile Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Mobile Number!",
                },
                {
                  pattern: mobilePattern,
                  message: "Please enter a valid mobile number",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                disabled
                placeholder="Enter Your Mobile Number!"
                name="mobile"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`SenderName`}
              label={"Sender Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter name!",
                },
              ]}
            >
              <CommonInput placeholder="Enter Your Name!" name="SenderName" />
            </Form.Item>{" "}
            <Form.Item
              name={`AadharNumber`}
              label={"Aadhaar Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter aadhaar mo.!",
                },
                {
                  pattern: aadharPattern,
                  message: "Please enter valid aadhaar",
                },
              ]}
            >
              <CommonInput
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Enter Your AadharNumber!"
                name="AadharNumber"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`SenderPin`}
              label={"Pin Code"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter PinCode!",
                },
                {
                  pattern: pincodePattern,
                  message: "Please enter a valid pin-code",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput placeholder="Enter PinCode!" name="SenderPin" />
            </Form.Item>{" "}
            <Form.Item
              name={`device`}
              label={"Select Device"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select any one device!",
                },
              ]}
            >
              <Select
                placeholder="Select a device"
                className="w-full mt-2"
                options={deviceOptions}
              />
            </Form.Item>{" "}
            <Form.Item>
              <Button
                htmlType="submit"
                loading={btnLoading}
                className="bg-primary mt-2 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
              >
                Submit
              </Button>
            </Form.Item>{" "}
          </Form>
        </div>
      </div>
      {isOpen && (
        <VerifyModal3
          isOpen={isOpen}
          from="register"
          setIsOpen={setIsOpen}
          endpoint={Globalendpoints.verifySender}
          otherFields={{
            BankId: provider,
            SenderMobileNumber: form.getFieldValue("mobile"),
            AadharNumber: otherfields.AadharNumber,
            AdditionalRegData: otherfields.SenderName,
            BioPid: formatXmlToSingleQuote(pidData),
            BioType: "FIR",
          }}
        />
      )}
    </>
  );
};

export default RemitterReg3;